module.exports = __webpack_public_path__ + "img/18.8c37ffda.jpg";